export const GET_TAG_DATA : string = "GET_TAG_DATA";
export const GET_TAG_DATA_By_Id : string = "GET_TAG_DATA_By_Id";
export const LOADING: string = "LOADING";

